module.exports = __webpack_public_path__ + "static/media/13b Illegal Grip.256229f9.jpg";